"use client";

// src/components/tabs/tabs.tsx
import { useState } from "react";
import { tabsStyles } from "./tabs.styles.mjs";
import { jsx, jsxs } from "react/jsx-runtime";
var Tabs = ({ tabs, name }) => {
  const style = tabsStyles();
  const [activeTab, setActiveTab] = useState(tabs[0].id);
  const handleKeyDown = (event, tabId) => {
    if (event.key === "ArrowRight" || event.key === "ArrowLeft") {
      event.preventDefault();
      const currentIndex = tabs.findIndex((tab) => tab.id === tabId);
      const newIndex = event.key === "ArrowRight" ? (currentIndex + 1) % tabs.length : (currentIndex - 1 + tabs.length) % tabs.length;
      setActiveTab(tabs[newIndex].id);
    }
  };
  return /* @__PURE__ */ jsxs("div", { className: style.container(), children: [
    /* @__PURE__ */ jsx("div", { className: style.tabs(), role: "tablist", "aria-label": name, children: tabs.map((tab) => /* @__PURE__ */ jsxs(
      "button",
      {
        className: style.tab({
          active: activeTab === tab.id
        }),
        role: "tab",
        id: `tab-${tab.id}`,
        "aria-label": `tab-${tab.id}`,
        "aria-selected": activeTab === tab.id,
        "aria-controls": `panel-${tab.id}`,
        tabIndex: activeTab === tab.id ? 0 : -1,
        onClick: () => setActiveTab(tab.id),
        onKeyDown: (event) => handleKeyDown(event, tab.id),
        children: [
          tab.label,
          /* @__PURE__ */ jsx(
            "div",
            {
              className: style.tabIndicator({
                active: activeTab === tab.id
              })
            }
          )
        ]
      },
      tab.id
    )) }),
    tabs.map((tab) => /* @__PURE__ */ jsx(
      "div",
      {
        className: style.tabContent(),
        role: "tabpanel",
        id: `panel-${tab.id}`,
        "aria-labelledby": `tab-${tab.id}`,
        hidden: activeTab !== tab.id,
        children: tab.content
      },
      tab.id
    ))
  ] });
};
export {
  Tabs
};
